import { render, staticRenderFns } from "./receivedGridExample.vue?vue&type=template&id=3ade100f&scoped=true&"
import script from "./receivedGridExample.vue?vue&type=script&lang=js&"
export * from "./receivedGridExample.vue?vue&type=script&lang=js&"
import style0 from "./receivedGridExample.vue?vue&type=style&index=0&id=3ade100f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade100f",
  null
  
)

export default component.exports